'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppRegisteredUser$$anon$6(evaluator$11) {
  this.Lapp_data_AppRegisteredUser$$anon$6__f_evaluator$1 = null;
  this.Lapp_data_AppRegisteredUser$$anon$6__f_evaluator$1 = evaluator$11;
}
export { $c_Lapp_data_AppRegisteredUser$$anon$6 as $c_Lapp_data_AppRegisteredUser$$anon$6 };
$c_Lapp_data_AppRegisteredUser$$anon$6.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppRegisteredUser$$anon$6.prototype.constructor = $c_Lapp_data_AppRegisteredUser$$anon$6;
/** @constructor */
function $h_Lapp_data_AppRegisteredUser$$anon$6() {
}
export { $h_Lapp_data_AppRegisteredUser$$anon$6 as $h_Lapp_data_AppRegisteredUser$$anon$6 };
$h_Lapp_data_AppRegisteredUser$$anon$6.prototype = $c_Lapp_data_AppRegisteredUser$$anon$6.prototype;
$c_Lapp_data_AppRegisteredUser$$anon$6.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_data_AppRegisteredUser$$anon$6.prototype.apply__s_Option = (function() {
  var v = this.Lapp_data_AppRegisteredUser$$anon$6__f_evaluator$1.apply__O();
  return ((v instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_ju_UUID) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_data_AppRegisteredUser$$anon$6.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_data_AppRegisteredUser$$anon$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppRegisteredUser$$anon$6, "app.data.AppRegisteredUser$$anon$6", ({
  Lapp_data_AppRegisteredUser$$anon$6: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_data_AppRegisteredUser$$anon$6 as $d_Lapp_data_AppRegisteredUser$$anon$6 };
//# sourceMappingURL=app.data.-App-Registered-User$$anon$6.js.map
